<template>
    <component :is="template">
        <v-container>
            <v-row>
                <v-col v-if="!$vuetify.breakpoint.mobile" cols="auto">
                    <category-list v-model="category" return-object/>
                </v-col>
                <v-col>
                    <div class="contents-area">
                        <div class="contents-area__inner">
                            <div class="category-icon-wrap border">
                                <div class="category-icon__inner" >
                                    <ul class="category-icon-ul">
                                        <li v-for="item in items" :class="item.class" :key="item._id" >
                                            <a @click="move(item._id)">
                                                <img :src="item.icon" :alt="item.name">
                                                <p class="icon-text">{{item.name}}</p>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </component>
</template>
<script>
import CategoryList from "../../../components/client/gshop/category/category-list.vue";
import api from '@/api';

const setIcon = ({ code }) => {
    if (code == "department") return "images/sub/icon1-on.png";
    if (code == "culture-game") return "images/sub/icon2-on.png";
    if (code == "google") return "images/sub/icon3-on.png";
    if (code == "food") return "images/sub/icon4-on.png";
    if (code == "store") return "images/sub/icon5-on.png";
    if (code == "coffee-cake") return "images/sub/icon6-on.png";
    return null
};
const setClass = ({ code }) => {
    if (code == "department") return "store";
    if (code == "culture-game") return "game";
    if (code == "google") return "code";
    if (code == "food") return "eatout";
    if (code == "store") return "convenience";
    if (code == "coffee-cake") return "coffee";
    return null
}

export default {
    components: {
        CategoryList,
    },
    data() {
        return {
            category: null,
            categories: [],
        };
    },
    computed: {
        template() {
            return () => import(`@/templates/${this.$theme.pages.gshop}`);
        },
        items() {
            return this.categories.map((category) => ({
                ...category,
                icon: setIcon(category),
                class: setClass(category)
            }));
        },
    },
    mounted(){
        this.init();
    },
    watch:{
        category(){
            this.$router.push(`/gshop/giftcards?_category=${this.category._id}`)
        }
    },
    methods: {
        async init(){
            let { categories } = await api.v1.gshop.categories.gets({ headers: { limit: 0 }, params: { depth: 0 } });
            this.categories = categories;
            this.sync()
        },
        move (id) {
            this.$router.push(`/gshop/giftcards?_category=${id}`)
        },
        sync(){
            if(this.category._id != this._category) this.category = ( this.categories || []).find(({_id})=> _id == this._category)
        }
    },
};
</script>

<style scoped>
.v-btn-toggle + .v-btn-toggle {
    margin-top: -1px;
}

.category-icon__inner {
    overflow:hidden;
}

.category-icon-ul {
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    background-color:#fff;
    padding-left: 0px;
    margin-left:-1px;
    margin-bottom: -1px;
}

.category-icon-ul li {
    flex: 1 1 33.33%;
    max-width:33.33%;
    text-align: center;
    border-left:1px solid rgba(0,0,0,.12);
    border-bottom:1px solid rgba(0,0,0,.12);
}

.category-icon-ul p {
    margin-bottom:0px;
    font-size:16px;
    font-weight:700;
    color:#22298b;
    transition: all ease .5s;
}

.category-icon-ul a {
    display: block;
    padding:20px 10px;
}

.category-icon-ul img {
    transition: all ease .3s;
}

/* .category-icon-ul li:hover p {
    font-weight:700;
    color:#22298b;
} */

/* .category-icon-ul .store:hover img, .category-icon-ul .store:active img {
    content:url('/images/sub/icon1-on.png');
}
.category-icon-ul .game:hover img, .category-icon-ul .game:active img {
    content:url('/images/sub/icon2-on.png');
}
.category-icon-ul .code:hover img, .category-icon-ul .code:active img {
    content:url('/images/sub/icon3-on.png');
}
.category-icon-ul .eatout:hover img, .category-icon-ul .eatout:hover img  {
    content:url('/images/sub/icon4-on.png');
}
.category-icon-ul .convenience:hover img, .category-icon-ul .convenience:active img {
    content:url('/images/sub/icon5-on.png');
}
.category-icon-ul .coffee:hover img, .category-icon-ul .coffee:hover img {
    content:url('/images/sub/icon6-on.png');
} */

@media (max-width:1024px) {

    .category-icon-ul img {
        max-width:140px;
    }

}

@media (max-width:640px) {

    .category-icon-ul li {
        flex:1 1 50%;
        max-width:50%;
    }

    .category-icon-ul a {
        padding:15px 10px;
    }

    .category-icon-ul img {
        max-width:94px;
    }

    .category-icon-ul p {font-size: 13px;}

}


</style>